import {useRef, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, Navigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {recuperarcontraseña, requestPassword} from '../core/_requests'
import {useIntl} from 'react-intl'
import emailjs from 'emailjs-com'
import {useNavigate} from 'react-router-dom'
import {RecoverPassword} from './RecoverPassword'

export function ForgotPassword() {
  const intl = useIntl()
  const initialValues = {
    email: '',
  }
  const navigate = useNavigate()
  
  const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILFORMAT'}))
      .min(3, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMIN'}))
      .max(50, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMAX'}))
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILREQUIRED'})),
  })

  const YOUR_USER_ID = 'IeZj3UCntaQLwHqmW'
  const YOUR_TEMPLATE_ID = 'template_osj3cp8'
  const YOUR_SERVICE_ID = 'service_6d05m59'
  const sendEmail = (values: any) => {
    // Evaluate condition before sending email
    if (values.id == '0') {
      // Send email using emailjs
      emailjs.send(YOUR_SERVICE_ID, YOUR_TEMPLATE_ID, {
        email:values.email,
        code:values.code
      }, YOUR_USER_ID)
    } 
  }

  const [loading, setLoading] = useState(false)
  
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [color, setColor] = useState<string>("")
  
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      
      // setHasErrors(undefined)
      // navigate("/auth/recover-password");
      // setTimeout(() => {
      //   requestPassword(values.email)
      //     .then(({data: {result}}) => {
      //       setHasErrors(false)
      //       setLoading(false)
      //     })

      //     .catch(() => {
      //       setHasErrors(true)
      //       setLoading(false)
      //       setSubmitting(false)
      //       setStatus('The login detail is incorrect')
      //     })
      // }, 1000)
      try {
        
        const {data: Recuperar} = await recuperarcontraseña(values.email, intl.locale.toUpperCase())
        // const form = useRef<HTMLFormElement>(null);
        console.log(Recuperar);
          if (Recuperar.msg_id == '0') {
            // sendEmail({id:Recuperar.id_msg,email:values.email,code:Recuperar.code})
            // console.log(Recuperar.txt_msg)
            setColor("success")
            setStatus(Recuperar.msg_txt)
            setTimeout(() => {
              navigate("/auth/recover-password");
            }, 4000);
            
            // const emailEnviado = formik.values.email;
            // localStorage.setItem('emailEnviado',emailEnviado);
            
            }
            
          else if (Recuperar.msg_id == '1') {
            setColor("danger")
          setStatus(Recuperar.msg_txt)
          setSubmitting(false)
          setLoading(false)
          // Mostrar mensaje de usuario no autorizado
          console.log(Recuperar.msg_txt)
        }
      } catch (error) {
        console.log('el error')
        console.error(error)
      }
    },
    
  })

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      // ref={form}
      onSubmit={(e)=>{
        formik.handleSubmit(e);
        sendEmail(e)
      }
      }
    >
      <div className='text-center mb-10'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>{intl.formatMessage({id: 'FORGOTP.TITLE'})}</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-500 fw-semibold fs-6'>
          {intl.formatMessage({id: 'FORGOTP.SUBTITLE'})}
        </div>
        {/* end::Link */}
      </div>

      {formik.status && (
        <div className={`mb-lg-15 alert alert-${color}`}>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

        

      {/* begin::Title */}
      {hasErrors === true && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>
            Sorry, looks like there are some errors detected, please try again.
          </div>
        </div>
      )}

      {hasErrors === false && (
        <div className='mb-10 bg-light-info p-8 rounded'>
          <div className='text-info'>Sent password reset. Please check your email</div>
        </div>
      )}
      {/* end::Title */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-gray-900 fs-6'>
          {intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}
        </label>
        <input
          type='email'
          placeholder={intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        {/* <Link to='/auth/recover-password'> */}
        <button
          type='submit'
          id='kt_password_reset_submit'
          className='btn btn-primary me-4'
          // onClick={()=>sendEmail}
        >
          <span className='indicator-label'>
            {intl.formatMessage({id: 'AUTH.GENERAL.SUBMIT_BUTTON'})}
          </span>
          {loading && (
            <span className='indicator-progress'>
              {intl.formatMessage({id: 'LOGIN.BTNWAIT'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='btn btn-light'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {intl.formatMessage({id: 'TEXT.CANCEL'})}
          </button>
        </Link>{' '}
      </div>
      {/* end::Form group */}
    </form>
  )
}
